import React, { useState } from "react";
import { Notification } from "../common/Notification";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as service from "../../store/service";
import * as LoginActions from "../../store/loginService/actions";
import { useTranslation } from "react-i18next";

const DeleteFamilyAccountDialog: React.FunctionComponent<{ closeDialog(): void; subCustomerId: string; showConfirmationPaymentInfo?: any; isUserPaid?: any }> = (
    props
) => {
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const accountToRemove = familyMembers.find((x) => x.subcustomerId === props.subCustomerId);
    const firstName = accountToRemove && accountToRemove.firstName ? accountToRemove.firstName : "";
    const lastName = accountToRemove && accountToRemove.lastName ? accountToRemove.lastName : "";
    const isHouseholdMember =
        accountToRemove &&
        accountToRemove.accountType &&
        (accountToRemove.accountType?.toLowerCase().includes("adult") || accountToRemove.accountType?.toLowerCase().includes("spouse"))
            ? true
            : false;
    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refreshFamilyMembersInformation = () => {
        getFamilyMembers();
        closeDialog();
    };

    const closeRemoveDialog = () => {
        closeDialog();
    };

    const removeAccount = () => {
        const requestBody = {
            subCustomerId: props.subCustomerId,
        };
        if (!!!props.isUserPaid) {
            setisLoading(true);
            service
                .removeIDFFamilyAccount(requestBody)
                .then((data) => {
                    if (data.hasError) {
                        Notification({
                            type: "error",
                            title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeHouseholdMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.errorMsgHeading"),
                            message: tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.errorMsgHeading", {name: firstName + " " + lastName}),
                        });
                    } else {
                        Notification({
                            type: "success",
                            title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeHouseholdMember.successMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.successMsgHeading"),
                            message: tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.successMsg", { name: firstName + " " + lastName }),
                            duration: 5,
                        });
                    }

                    refreshFamilyMembersInformation();
                    setisLoading(false);
                })
                .catch(() => {
                    Notification({
                        type: "error",
                        title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeHouseholdMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.errorMsgHeading"),
                        message: tLang("manageAccount.myAccount.familyProtection.toastMsgs.removeChildMember.errorMsgHeading", { name: firstName + " " + lastName }),
                    });
                    refreshFamilyMembersInformation();
                    setisLoading(false);
                });
        } else {
            props.showConfirmationPaymentInfo(props.isUserPaid);
            closeRemoveDialog();
        }
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-minus-circle"></em>
                        </div>
                        <h1>{isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.removeHouseholdMemberText") : tLang("manageAccount.myAccount.familyProtection.removeChildMemberText")}</h1>{}
                    </div>

                    <div className="dialog-body">
                        <p>
                            {tLang("manageAccount.myAccount.familyProtection.removeStatement")}{" "}
                            <strong>
                                {firstName} {lastName}
                            </strong>
                            ?
                        </p>
                        {props.isUserPaid && <p>{tLang("manageAccount.myAccount.familyProtection.isUserPaidStatement")}</p>}
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                    <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.cancelBtnText")}</span>
                                </button>
                            </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" onClick={removeAccount} className="btn-default btn-primary">
                                    <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.removeBtnText")}</span> {/* BUG 20486 */}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default DeleteFamilyAccountDialog;
